import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import excel from 'vue-excel-export'
import vueXlsxTable from 'vue-xlsx-table'
import VueExcelXlsx from "vue-excel-xlsx";


Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$urlAPI = 'https://prazos-api.lemetech.com/api'
//Vue.prototype.$urlAPI = 'http://localhost:8000/api'

Vue.use(excel);
Vue.use(vueXlsxTable, {rABS: false});
Vue.use(VueExcelXlsx);

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
